import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faCars,
    faFamily,
    faPersonDressSimple,
    faPersonSimple,
} from '@fortawesome/pro-solid-svg-icons';
import type { Location } from './types';
import type { TripUrlParams } from './trip';

export enum SellTypeCode {
    Male = 1,
    Female = 2,
    Family = 3,
    Car = 4,
}

export interface SellType {
    code: SellTypeCode;
    title: string;
    description: string;
    icon: IconDefinition;
}

export interface TrainLocation extends Location<TrainLocation> {
    stationId: number;
    longitude?: number;
    latitude?: number;
}

export const trainSellTypes: SellType[] = [
    {
        code: SellTypeCode.Family,
        title: 'مسافرین عادی',
        description: 'ویژه افرادی که خانوادگی مسافرت می‌کنند.',
        icon: faFamily,
    },
    {
        code: SellTypeCode.Male,
        title: 'ویژه برادران',
        description: 'ویژه آقایانی که تنها مسافرت می‌کنند.',
        icon: faPersonSimple,
    },
    {
        code: SellTypeCode.Female,
        title: 'ویژه خواهران',
        description: 'ویژه خانم‌هایی که تنها مسافرت می‌کنند.',
        icon: faPersonDressSimple,
    },
    {
        code: SellTypeCode.Car,
        title: 'حمل خودرو',
        description: 'ویژه حمل خودروی سواری',
        icon: faCars,
    },
];

export interface TrainUrlParams extends TripUrlParams {
    originCode: number;
    destinationCode: number;
    sellTypeCode?: SellTypeCode;
    exclusive: boolean;
}
